import type { DiagramDocument } from '../../core/types';
import { validateDocument } from '../../core/validation';
import { normalizeDocument } from '../../core/normalize';
import { listLocalDocuments, saveLocal } from './localRepository';
import { importCustomSymbolsJson, loadCustomSymbols, type CustomSymbolPreset } from './customLibrary';
import { importCustomTemplatesJson, loadCustomTemplates, type CustomTemplatePreset } from './customTemplates';

export interface WorkspaceBackup {
  format: 'owdex-draw-workspace-backup';
  version: 1;
  createdAt: string;
  documents: DiagramDocument[];
  symbols: CustomSymbolPreset[];
  templates: CustomTemplatePreset[];
}

export async function exportWorkspaceBackup(): Promise<string> {
  const backup: WorkspaceBackup = { format: 'owdex-draw-workspace-backup', version: 1, createdAt: new Date().toISOString(), documents: await listLocalDocuments(), symbols: loadCustomSymbols(), templates: loadCustomTemplates() };
  return JSON.stringify(backup, null, 2);
}

export async function importWorkspaceBackup(text: string): Promise<{ documents: number; symbols: CustomSymbolPreset[]; templates: CustomTemplatePreset[] }> {
  if (text.length > 50 * 1024 * 1024) throw new Error('Backup excede o limite local de 50 MB.');
  const raw = JSON.parse(text) as unknown; if (!raw || typeof raw !== 'object') throw new Error('Backup inválido.');
  const root = raw as Partial<WorkspaceBackup>;
  if (root.format !== 'owdex-draw-workspace-backup' || root.version !== 1 || !Array.isArray(root.documents) || !Array.isArray(root.symbols) || !Array.isArray(root.templates)) throw new Error('Formato de backup não reconhecido.');
  const docs = root.documents.filter((doc): doc is DiagramDocument => validateDocument(doc).valid).map(normalizeDocument);
  if (docs.length !== root.documents.length) throw new Error('O backup contém projeto inválido e não foi restaurado.');
  // Reaproveita os validadores públicos das bibliotecas sem tocar em sincronização/outbox.
  const symbolsPayload = JSON.stringify({ format: 'owdex-draw-custom-library', version: 1, symbols: root.symbols });
  const templatesPayload = JSON.stringify({ format: 'owdex-draw-custom-templates', version: 1, templates: root.templates });
  const symbols = importCustomSymbolsJson(symbolsPayload); const templates = importCustomTemplatesJson(templatesPayload);
  for (const doc of docs) await saveLocal(doc);
  return { documents: docs.length, symbols, templates };
}
